import axios from 'axios';
import { getApiBaseUrl } from './api';

export interface E2bPriceCheck {
  vcpu_hour_usd: number | null;
  gib_hour_usd: number | null;
  plan_monthly_usd: number | null;
  source: string | null;
  read_at: string | null;
  checked_at: string | null;
  failing_since: string | null;
  differs: boolean;
}

export interface PricingSettings {
  seat_price_cents: number;
  seat_allowance_cents: number;
  topup_threshold_cents: number;
  topup_amount_cents: number;
  free_starter_credit_cents: number;
  deep_scoping_price_cents: number;
  platform_margin_percent: number | null;
  compute_margin_percent: number | null;
  compute_vcpu_hour_usd: number | null;
  compute_gib_hour_usd: number | null;
  e2b_vcpu_hour_usd: number | null;
  e2b_gib_hour_usd: number | null;
  e2b_price_check: E2bPriceCheck | null;
  bill_aibot_usage: boolean;
  builder_available: boolean;
}

export type PricingUpdate = Partial<Omit<PricingSettings, 'builder_available' | 'e2b_vcpu_hour_usd' | 'e2b_gib_hour_usd' | 'e2b_price_check'>>;

export interface RateCardModel {
  model: string;
  provider: string;
  label?: string | null;
  input: number;
  output: number;
  cacheRead: number;
  cacheWrite: number;
  override: boolean;
}

export interface RateCard {
  currency: string;
  seat_price_cents: number;
  seat_allowance_cents: number;
  models: RateCardModel[];
  compute: {
    perVcpuSecond: number;
    perGibSecond: number;
    standardBoxPerHour: number;
    standardBox: { vcpu: number; memoryGib: number };
  } | null;
  usage_rates_available: boolean;
}

export const pricingApi = {
  getPricing: () => axios.get<PricingSettings>(`${getApiBaseUrl()}/super/pricing`),
  updatePricing: (update: PricingUpdate) => axios.put<PricingSettings>(`${getApiBaseUrl()}/super/pricing`, update),
  checkE2bPrices: () => axios.post<PricingSettings>(`${getApiBaseUrl()}/super/pricing/e2b-check`),
  getRateCard: () => axios.get<RateCard>(`${getApiBaseUrl()}/pricing/rate-card`),
};
